import { createContext, FC, useCallback, useState } from "react";
import { ReactElementProps } from "../../types";
import { ConferencePlaybackClient } from "@ciptex/conference-playback-sdk";
import { ConferencePlaybackContextType } from "../../types/ciptex-sdk";
import { useAppState } from "../../hooks/useAppState/useAppState";
import { Role } from "@ciptex/notified";

export const ConferencePlaybackContext = createContext<ConferencePlaybackContextType>(null!);

export const ConferencePlaybackProvider: FC<ReactElementProps> = ({ children }: ReactElementProps) => {
	const [conferencePlaybackClient, setConferencePlaybackClient] = useState<ConferencePlaybackClient>();
	const { appState } = useAppState();
	const [ playState, setPlayState ] = useState<"playing" | "paused" | "stopped">("stopped")

	const connect = useCallback(
		(token: string) => {
			try {
				const client = new ConferencePlaybackClient({ token: token });
				setConferencePlaybackClient(client);

				const { conferenceId, participantType } = appState;

				if (conferenceId && participantType && [Role.NOTIFIED_ADMIN, Role.NOTIFIED_HOST].includes(participantType)) {
					client.audio.getApplicationCookie({ conferenceId });
				}
			} catch (error: any) {
				console.error("[CIPTEX]", error)
			}
		}, []);

	const playUrl = async (url: string, loop = false) => {
		await conferencePlaybackClient?.audio.play({
			url,
			conferenceId: appState.conferenceId,
			accountSid: appState.accountSid,
			loop,
			cid: appState.conferenceId
		});

		setPlayState("playing");
	};

	const stop = async () => {
		await conferencePlaybackClient?.audio.stop({
			conferenceId: appState.conferenceId,
			cid: appState.conferenceId
		});

		setPlayState("stopped");
	}

	const toggle = async () => {
		await conferencePlaybackClient?.audio.toggle({
			conferenceId: appState.conferenceId,
			cid: appState.conferenceId
		});

		setPlayState(playState === "playing" ? "paused" : "playing");
	}

	return <ConferencePlaybackContext.Provider value={{ connect, playUrl, stop, toggle  }}>{children}</ConferencePlaybackContext.Provider>;
}